export default {
  common: {
    accept: 'OK',
    cancel: 'Cancel',
    close: 'Close',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    copy: 'Copy',
    retry: 'Retry',
    loading: 'Loading…',
    search: 'Search',
    confirm: 'Confirm',
    yes: 'Yes',
    no: 'No',
    back: 'Back',
    none: 'None',
    all: 'All',
    clear: 'Clear',
    refresh: 'Refresh',
    prev: 'Previous',
    next: 'Next',
    sending: 'Sending…',
  },
  nav: {
    library: 'Library',
    import: 'Import',
    cloud: 'In the cloud',
    settings: 'Settings',
    stats: 'Statistics',
    knowledge: 'Knowledge',
    review: 'Review',
    discover: 'Discover',
    clubs: 'Clubs',
    notifications: 'Notifications',
    account: 'Account',
    skipToContent: 'Skip to content',
    openMenu: 'Open menu',
    closeMenu: 'Close menu',
    search: 'Search',
  },
  import: {
    title: 'Import books',
    subtitle: 'Add EPUBs to your library. Files are stored only in this browser.',
    dropTitle: 'Drag your EPUBs here',
    dropHint: 'or click to choose files · you can import several at once',
    lastReport: 'Last import',
    reportImported: '{count} book(s) imported | {count} book imported | {count} books imported',
    reportSkipped: '{count} duplicate(s) skipped | {count} duplicate skipped | {count} duplicates skipped',
    reportFailed: '{count} failed | {count} failed | {count} failed',
    goToLibrary: 'Go to library',
    helpTitle: 'Tips',
    help1: 'You can import several EPUBs at once by dragging or selecting them.',
    help2: 'If a file is already in your library (same content), it is skipped automatically.',
    help3: 'Files are not uploaded to any server; they live in the browser’s local storage.',
  },
  shelves: {
    manage: 'Manage shelves',
    manageHide: 'Hide management',
    createButton: 'Create',
    createPlaceholder: 'Shelf name…',
    descriptionPlaceholder: 'Optional description…',
    pickColor: 'Pick a color',
    noColor: 'No color',
    bookCount: '{count} book(s) | {count} book | {count} books',
    created: 'Shelf “{name}” created.',
    updated: 'Shelf updated.',
    deleted: 'Shelf “{name}” deleted.',
    empty: 'No shelves yet. Create the first one above.',
    addToShelf: 'Add to shelf',
    inShelves: 'In shelves',
    none: 'None',
    organize: {
      button: 'Organize by metadata',
      title: 'Organize by metadata',
      intro: 'Automatically create shelves by grouping your books by a field.',
      field: 'Group by',
      'field.author': 'Author',
      'field.publisher': 'Publisher',
      'field.language': 'Language',
      'field.collection': 'Series',
      mode: 'If a shelf with that name already exists',
      'mode.merge': 'Merge (add without removing)',
      'mode.replace': 'Replace (clear and refill)',
      preview: 'Preview',
      previewSummary:
        '{created} {created, plural, =0 {new shelves will be created} one {new shelf will be created} other {new shelves will be created}}, {updated} {updated, plural, one {existing shelf} other {existing shelves}} will be updated, and {skipped} {skipped, plural, one {book without a value} other {books without a value}} will be skipped.',
      emptyGroups: 'No groups for the current books and field.',
      apply: 'Apply',
      applying: 'Applying…',
      cancel: 'Cancel',
      result:
        '{created} {created, plural, one {shelf was} other {shelves were}} created, {updated} updated.',
    },
    reextract: {
      button: 'Generate tags from EPUBs',
      confirmTitle: 'Generate tags from EPUBs',
      confirmMessage:
        'Re-reads each EPUB and adds its genres (<dc:subject>) to your tags, without overwriting existing ones. Only processes books with a local file. May take a while on large libraries.',
      apply: 'Generate',
      applying: 'Generating…',
      result:
        'Tags updated in {updated} {updated, plural, one {book} other {books}}, {unchanged} unchanged, {missing} without a local file, and {failed} {failed, plural, one {failure} other {failures}}.',
    },
  },
  cloud: {
    title: 'In the cloud',
    subtitle: '{count} book(s) in the cloud | {count} book in the cloud | {count} books in the cloud',
    searchPlaceholder: 'Search by title or author…',
    hideLocal: 'Hide books already on this device',
    refresh: 'Refresh',
    extractCovers: 'Recover covers',
    extractCoversHint: 'Extract covers for books missing them (processed on the server)',
    extractCoversStarting: 'Recovering covers from the cloud…',
    extractCoversRunning: 'Recovering…',
    extractCoversDone: '{n} cover(s) recovered.',
    extractCoversPartial: 'Recovered {ok}, failed {fail}.',
    extractCoversFailed: 'Could not recover any cover.',
    extractCoversNothing: 'All covers were already present.',
    loading: 'Loading cloud library…',
    empty: 'You have no books in the cloud yet.\nUpload one from a book’s detail to see it here on other devices.',
    emptyFiltered: 'No books match the search or filter.',
    onDevice: 'On this device',
    downloading: 'Downloading…',
    download: 'Download',
    // Main action: opens the book to read instantly (transparent
    // background download). This is the new default flow.
    read: 'Read',
    opening: 'Opening…',
    // Explicit "save offline": downloads the book without opening it, to
    // have it available without a connection (e.g. a flight).
    saveOffline: 'Save offline',
    savingOffline: 'Saving…',
    prev: 'Previous',
    next: 'Next',
    pageOf: 'Page {page} of {total}',
    signInPrompt: 'Sign in and enable sync to see your cloud books.',
    goToAuth: 'Sign in',
    goToSettings: 'Go to Settings',
    uploadAll: 'Upload all local',
    uploadAllHint: 'Upload {n} book(s) from your library to the cloud',
    uploadFiles: 'Upload files',
    uploadNothing: 'No local books pending to upload.',
    uploadStarting: 'Uploading {n} book(s) to the cloud…',
    uploadingItem: 'Uploading {current} of {total}',
    uploadFinished: 'Upload complete',
    uploadAllDone: '{n} book(s) uploaded to the cloud.',
    uploadPartial: 'Uploaded {ok}, failed {fail}. See details.',
    uploadFailed: 'Could not upload any book.',
    uploadAlreadyRunning: 'An upload is already running.',
    deleteFromCloud: 'Delete from cloud',
    deleteConfirm: 'Delete "{title}" from the cloud?\n\nThe local copy on this device will not be removed.',
    deleted: 'Book deleted from the cloud.',
    fileTooLarge: 'The file is {size} MB. The per-file limit in the cloud is 50 MB.',
    // Selection mode (bulk delete from cloud)
    selectMode: 'Select',
    exitSelection: 'Exit',
    selectAll: 'Select all',
    clearSelection: 'Clear',
    cancelSelection: 'Cancel',
    selectedCount: '{n} selected',
    deleteSelected: 'Delete',
    deleteSelectedConfirm:
      'Delete {n} book(s) from the cloud?\n\nLocal copies on your devices will not be removed. Only the cloud copies will be deleted.',
    deletedMany: '{n} book(s) deleted from the cloud.',
    deletePartial: 'Deleted {ok}, failed {fail}. Check the list.',
    deleteFailed: 'Could not delete any book from the cloud.',
  },
  search: {
    title: 'Search your library',
    placeholder: 'Search across your books and annotations…',
    searching: 'Searching…',
    noResults: 'No results.',
    resultsCount: '{count} result(s) | {count} result | {count} results',
    groupBook: 'Book',
    groupHighlight: 'Annotation',
    openInReader: 'Open in reader',
    chapter: 'Chapter',
    annotation: 'Annotation',
    shortcutHint: 'Press Ctrl/⌘+K to search',
    indexingBooks: 'Indexing library…',
    migrationProgress: 'Indexing {done} of {total} books…',
    migrationDone: 'Library indexed.',
    openButton: 'Search content',
  },
  knowledge: {
    title: 'Knowledge',
    subtitle: 'Your annotations grouped into themes and linked to each other.',
    themesCount: '{count} theme(s) | {count} theme | {count} themes',
    memberCount: '{count} annotation(s) | {count} annotation | {count} annotations',
    analyzing: 'Analyzing your annotations…',
    empty: 'No themes yet. Create more annotations to surface connections.',
    noEmbeddings: 'To generate themes and semantic connections you need an embeddings provider (OpenAI or Ollama).',
    embeddingNeeded: 'Go to Settings',
    backlinks: 'Linked from',
    related: 'Related',
    relatedEmpty: 'Finding related…',
    connections: 'Connections',
    aliasNotFound: 'No note found for «{alias}».',
    wikiHint: 'Write [[alias]] in your notes to link them together.',
  },
  rag: {
    askBook: 'Ask the book',
    askLibrary: 'Ask the library',
    placeholder: 'Ask about the content…',
    thinking: 'Thinking…',
    cited: 'Grounded answers with citations',
    jumpToCitation: 'Go to cited passage',
    jumpFailed: 'Could not go to citation: {reason}',
    bookNotFound: 'The cited book is no longer in the library.',
    noAnswer: 'I could not find information about that in the context.',
    needsEmbeddings: 'This feature requires an embeddings provider (OpenAI or Ollama) in Settings → AI.',
    crossSummary: 'Cross summary',
    selectBook1: 'Book 1',
    selectBook2: 'Book 2',
    topic: 'Topic to compare',
    topicPlaceholder: 'e.g. attention, memory, freedom…',
    generate: 'Generate',
    crossUserPrompt: 'Compare how these two books treat the given topic.',
    crossFailed: 'Could not generate the cross summary: {reason}',
  },
  librarian: {
    badge: 'Librarian',
    intro: "I'm The Librarian. Ask me for recommendations: «what should I read after finishing X?», «something short in sci-fi», «similar to Y»…",
  },
  review: {
    title: 'Review',
    subtitle: 'Review your annotations with spaced repetition to retain them.',
    empty: 'You have no review cards yet.',
    emptyHint: 'Open a book, highlight text and tap the review button (⏰) on its annotations.',
    start: 'Start review',
    queue: 'Queue',
    ofN: 'of {total}',
    done: 'reviewed',
    completed: 'Session complete!',
    showAnswer: 'Show answer',
    again: 'Again',
    hard: 'Hard',
    good: 'Good',
    easy: 'Easy',
    dueToday: 'due today',
    filters: 'Filters',
    allBooks: 'All books',
    allColors: 'All colors',
    onlyDue: 'Due only',
    addToReview: 'Add to review',
    removeFromReview: 'Remove from review',
    generateQuestion: 'Generate question',
    questionReady: 'Question ready',
    noCards: 'No cards match these filters.',
  },
  share: {
    title: 'Shared reading',
    createLink: 'Create reading link',
    createFailed: 'Could not create the shared link.',
    linkCopied: 'Link copied to clipboard. Share it with your reading club.',
    hint: 'Anyone opening the link will see this book’s annotations in real time and can download it.',
    accepting: 'Accepting invitation…',
    downloading: 'Downloading shared book…',
    inviteAccepted: 'You joined the shared reading.',
    inviteAcceptedHint: 'The book has been added to your library. Open it to see and add joint annotations.',
    inviteFailed: 'Could not join the reading. The link may have expired.',
    missingShare: 'The invitation id is missing from the link.',
    redirecting: 'Taking you to your library…',
    retry: 'Retry',
    goToLibrary: 'Go to library',
    memberHint: 'You received this book by invitation. Annotations sync in real time with whoever shared it.',
    leaveShare: 'Leave shared book',
    leaveShareConfirmBody: 'Leave this shared book? It will be removed from your library. You can rejoin with the invitation link.',
    leaveDone: 'You left the shared book.',
    leaveFailed: 'Could not leave the shared book. Try again.',
    roles: { owner: 'Owner', annotator: 'Annotator', viewer: 'Viewer' },
    viewerHint: 'You are in read-only mode. You cannot add annotations or comments.',
    inviteByEmail: 'Or invite by email',
    emailPlaceholder: "friend{'@'}domain.com",
    sendInvite: 'Send invite',
    inviteSent: 'Invite sent to {email}.',
  },
  discover: {
    title: 'Discover',
    subtitle: 'Quotes other readers have shared publicly.',
    empty: 'No public quotes yet. Share one from your annotations.',
    loadMore: 'Load more',
    noMore: 'No more quotes.',
    scopeGlobal: 'Global',
    scopeFollowing: 'Following',
    sortRecent: 'Recent',
    sortTop: 'Top',
    report: 'Report',
    reported: 'Reported. Thank you.',
    reportFailed: 'Could not report.',
    reportPlaceholder: 'Why are you reporting?',
    sendReport: 'Send report',
    publishAction: 'Publish to Discover',
    published: 'Published to Discover (click to remove)',
    publishedToast: 'Quote published to Discover.',
    unpublished: 'Quote removed from public feed.',
    publishFailed: 'Could not publish the quote.',
  },
  library: {
    title: 'Library',
    heroEyebrow: 'Your reading nook',
    import: 'Import',
    importHint: 'Drag EPUB files here or click to select',
    imported: '{count} book(s) imported | {count} book imported | {count} books imported',
    importFailed: 'Could not import "{name}": {reason}',
    deleted: 'Book removed from library',
    empty: 'Your library is empty. Import an EPUB to get started.',
    searchPlaceholder: 'Search by title or author…',
    filterAll: 'All',
    filterUnread: 'Unread',
    filterReading: 'Reading',
    filterFinished: 'Finished',
    sortByRecent: 'Recent',
    sortByTitle: 'Title',
    sortByAuthor: 'Author',
    sortByProgress: 'Progress',
    cover: 'Cover',
    open: 'Open',
    importing: 'Importing books…',
    loadingLibrary: 'Loading library…',
    allTags: 'All',
    allShelves: 'All',
    noMatches: 'No books match the current filters.',
    bookCount: '{count} book(s) in total | {count} book in total | {count} books in total',
    errorLabel: 'Error: {message}',
    continueReading: 'Continue reading',
    continueButton: 'Continue',
    sectionReading: 'Reading',
    sectionNotStarted: 'Not started',
    sectionRecentlyFinished: 'Recently finished',
    sectionFavorites: 'Favorites',
    sectionAll: 'Your collection',
    sectionResults: 'Results',
    sectionCloud: 'In the cloud',
    sectionCloudHint: 'Your books not on this device',
    viewAllCloud: 'View all in cloud',
    alsoInCloud: 'Available in the cloud',
    cloudOnly: 'Cloud only',
    viewCloudManagement: 'Manage in cloud',
    loadMore: 'Load more',
    density: 'Grid density',
    density_compact: 'Compact',
    density_comfortable: 'Comfortable',
    density_list: 'List',
    importSkipped: '“{name}” is already in your library as “{existing}”. Skipped.',
    deleteBook: 'Remove from library',
    favorite: 'Mark as favorite',
    unfavorite: 'Remove from favorites',
    addedToFavorites: 'Added to favorites',
    favorites: 'Favorites',
    favoritesHint: 'Show only your favorite books',
    removedFromFavorites: 'Removed from favorites',
    sharedChip: 'Shared',
    sharedBadge: 'Shared book',
    uploadToCloud: 'Upload to cloud',
    uploadedToCloud: 'Uploaded to cloud',
    alreadyInCloud: 'Already in cloud',
    addToShelf: 'Add to shelf',
    shelvesEmpty: 'You have no shelves. Create them in Settings.',
    // Alphabetical index (A-Z)
    alphaIndex: 'Alphabetical index',
    alphaAll: 'All',
    alphaOther: '#',
    alphaModeTitle: 'Titles',
    alphaModeAuthor: 'Authors',
    // Selection mode (bulk delete from the library)
    selectMode: 'Select',
    exitSelection: 'Exit',
    selectAll: 'Select all',
    clearSelection: 'Clear',
    cancelSelection: 'Cancel',
    selectedCount: '{n} selected',
    deleteSelected: 'Delete',
    deleteSelectedConfirm:
      'Delete {n} book(s) from your library?\n\nThis action cannot be undone. Their annotations, summaries and reading progress will also be removed.',
    deletedMany: '{n} book(s) deleted',
    deleteFromCloudToo: 'Also delete from cloud ({uploaded} of {total} are uploaded)',
  },
  onboarding: {
    title: 'Welcome to EPUB Unlimited',
    subtitle: 'Your offline-first reading nook with annotations, AI and cross-device sync. Start by importing your first book.',
    importEpub: 'Import EPUB',
    importEpubHint: 'Pick one or more files from your device.',
    loadDemo: 'Load sample book',
    loadDemoHint: 'Downloads "Don Quixote" (public domain) to try.',
    demoLoading: 'Downloading…',
    demoSuccess: 'Sample book loaded.',
    demoAlready: 'You already had the sample book in your library.',
    demoError: 'Could not download the sample book. Check your connection.',
    offlineHint: 'Requires an internet connection.',
    configureSync: 'Set up sync / AI',
    configureSyncHint: 'Enable cloud sync and/or your AI provider.',
    importSuccess: '{n} book(s) imported.',
    importSkipped: '{n} duplicate(s) skipped.',
    importFailed: '{n} file(s) failed to import.',
    dismiss: "Don't show again",
    showAgain: 'Show getting started guide',
  },
  bookDetail: {
    author: 'Author',
    language: 'Language',
    publisher: 'Publisher',
    isbn: 'ISBN',
    description: 'Synopsis',
    tags: 'Tags',
    addTag: 'Add tag',
    collection: 'Collection',
    status: 'Status',
    rating: 'Rating',
    noRating: 'Not rated',
    setRating: 'Rate {n} star(s) | Rate {n} star | Rate {n} stars',
    editMetadata: 'Edit metadata',
    enrichMetadata: 'Improve metadata',
    enriching: 'Improving…',
    enriched: 'Metadata improved: {fields}.',
    enrichFailed: 'Could not improve metadata: {reason}',
    alreadyComplete: 'Metadata was already complete.',
    titleLabel: 'Title',
    authorLabel: 'Author',
    changeCover: 'Change cover',
    coverNotImage: 'The selected file is not an image.',
    coverUpdated: 'Cover updated.',
    progress: 'Progress',
    openBook: 'Read',
    deleteBook: 'Delete',
    deleteConfirm: 'Delete this book? This action cannot be undone.',
    toggleSelect: 'Select or deselect this book',
    cloud: 'Cloud',
    uploadToCloud: 'Upload to cloud',
    uploading: 'Uploading…',
    uploaded: 'Book uploaded to cloud.',
    downloadFromCloud: 'Download',
    downloaded: 'Book downloaded from cloud.',
    inCloud: 'In cloud',
    removeFromCloud: 'Remove from cloud',
    removeCloudConfirm: 'Remove this book from the cloud?',
    removedFromCloud: 'Book removed from cloud.',
    citation: 'Citation',
    copyCitation: 'Copy citation',
    citationCopied: 'Citation copied to clipboard.',
    uploadFailed: 'Could not upload: {reason}',
    downloadFailed: 'Could not download: {reason}',
    backToLibrary: '← Back to library',
    loading: 'Loading…',
    bookNotFound: 'Book not found.',
    continueReading: 'Continue reading',
    startReading: 'Start reading',
    statusLabel: 'Status:',
    statusUnread: 'To read',
    statusReading: 'Reading',
    statusFinished: 'Read',
    details: 'Details',
    publisherLabel: 'Publisher:',
    languageLabel: 'Language:',
    isbnLabel: 'ISBN:',
    published: 'Published:',
    added: 'Added:',
    removeTag: 'Remove tag',
    addPlaceholder: 'Add…',
    add: 'Add',
    collectionLabel: 'Collection / Series',
    collectionPlaceholder: 'e.g. Foundation Trilogy',
    syncHint: 'Enable sync in Settings to upload this book to the cloud and read it on other devices.',
    cloudRemoveFailed: 'Could not remove: {reason}',
  },
  audio: {
    nowPlaying: 'Now playing',
    play: 'Play',
    pause: 'Pause',
    next: 'Next',
    prev: 'Previous',
    seekBack: 'Back {n}s',
    seekForward: 'Forward {n}s',
    seekUnavailable: 'The browser voice cannot seek within the audio: switch to neural',
    stop: 'Close player',
    openInReader: 'Open in reader',
    miniBar: 'Audiobook player',
    rate: 'Speed',
    sleep: 'Sleep timer',
    sleepOff: 'No timer',
    sleepMinutes: '{n} min',
    sleepChapter: 'End of chapter',
    engine: 'Voice',
    engineBrowser: 'Browser (free)',
    engineNeural: 'Neural (audiobook)',
    engineNeuralUnavailable: 'Neural voice requires OpenAI or an ElevenLabs key in Settings → AI',
    voice: 'Neural voice',
    estimatedCost: 'Estimated cost for this book: ~{usd} USD',
    browserEngineGone: 'Browser voice needs the reader open. Paused.',
    switchToNeural: 'Switch to neural',
    browserEngineGoneNoNeural: 'Browser voice needs the reader open. Reopen it to keep listening.',
    backToReader: 'Back to reader',
    resumeUnavailable: 'No voice to continue with: open the reader or switch to neural',
    cacheTitle: 'Audio cache',
    cacheHint: 'Neural audio is stored so you never pay for it twice. ~1 MB per minute.',
    cacheLimit: 'Cache limit (MB)',
    cacheUsed: 'Used: {mb} MB',
    cacheClear: 'Clear audio cache',
    cacheClearConfirm: 'All audio already generated for your books will be deleted. Listening again will synthesize (and charge) it again.',
    cacheCleared: 'Audio cache cleared',
    preparing: 'Preparing audio…',
    neuralNoText: 'This book has no text the neural voice can read. Switched back to the browser voice.',
    neuralError: 'Could not generate the audio: {reason}',
  },
  reader: {
    openingBook: 'Opening book…',
    openError: 'Could not open the book.',
    notFound: 'Book not found.',
    toc: 'Contents',
    tocEmpty: 'This book has no table of contents.',
    toggleToc: 'Open contents',
    searchInBook: 'Search in book',
    searchResults: '{count} results',
    searchEmpty: 'Type to search in the book.',
    searchPlaceholder: 'Text to search…',
    searchProgress: 'Searching…',
    searchEmptyHint: 'Type a term and press Search.',
    searchClear: 'Clear results',
    chapter: 'Chapter',
    pageNext: 'Next page',
    pagePrev: 'Previous page',
    toolbarMore: 'More tools',
    closeToolbar: 'Close',
    toolbarGroupNav: 'Navigation',
    toolbarGroupContent: 'Content',
    toolbarGroupAi: 'Artificial intelligence',
    toolbarGroupAppearance: 'Appearance',
    zen: 'Zen mode',
    exitZen: 'Exit Zen mode',
    shortcutsTitle: 'Keyboard shortcuts',
    shortcuts: {
      nextPage: 'Next page',
      prevPage: 'Previous page',
      toggleToc: 'Open/close table of contents',
      toggleSearch: 'Open/close search',
      toggleAnnotations: 'Open/close annotations',
      toggleZen: 'Toggle Zen mode',
      toggleShortcuts: 'Show this panel',
      closePopover: 'Close the selection popover',
    },
    appearance: 'Appearance & typography',
    layout: 'Layout',
    flowPaginated: 'Paginated',
    flowScrolled: 'Continuous scroll',
    searchAnnotations: 'Search annotations…',
    annotationsNoMatches: 'No annotation matches the search.',
    annotations: 'Annotations',
    annotationsEmpty: 'No annotations in this book yet.\nSelect text while reading to highlight.',
    editNote: 'Edit note',
    deleteAnnotation: 'Delete annotation',
    comments: 'Comments',
    commentPlaceholder: 'Write a comment…',
    summaries: 'Summaries',
    summariesAction: 'AI summaries',
    viewSummaries: 'View summaries',
    chatAction: 'Chat about the book',
    openChat: 'Open contextual chat',
    bilingual: 'Bilingual reading',
    translate: 'Translate',
    bilingualEmpty: 'Press “Translate” to see the section in two languages.',
    landmarks: 'Index',
    landmarksEmpty: 'This book has no index.',
    studyQuestions: 'Study questions',
    generateQuestions: 'Generate questions',
    studyEmpty: 'Press “Generate questions” to get comprehension questions for the current chapter.',
    copyCitation: 'Copy as citation',
    pomodoro: 'Pomodoro',
    pomodoroFocus: 'Focus',
    pomodoroBreak: 'Break',
    pomodoroLongBreak: 'Long break',
    pomodoroStart: 'Start',
    pomodoroPause: 'Pause',
    pomodoroSkip: 'Skip',
    summarizeHighlights: 'Summarize my annotations',
    noHighlightsToSummarize: 'No annotations to summarize yet.',
    translations: 'Translations',
    viewTranslations: 'View translations',
    viewAnnotations: 'View annotations',
    bookmarks: 'Bookmarks',
    bookmarksEmpty: 'No bookmarks yet.\nClick the bookmark icon in the top bar to add one.',
    toggleBookmark: 'Toggle bookmark on current page',
    addBookmarkHere: 'Bookmark current page',
    viewBookmarks: 'View bookmarks',
    deleteBookmark: 'Delete bookmark',
    closeReader: 'Close reading',
    tts: 'Read aloud',
    ttsPrev: 'Previous fragment',
    ttsNext: 'Next fragment',
    ttsPause: 'Pause reading',
    ttsPlay: 'Read aloud',
    ttsStop: 'Stop reading',
    ttsRate: 'Speed',
    ttsRateFull: 'Reading speed',
    ttsRateShort: 'Spd',
    ttsControls: 'Read aloud controls',
    ttsUnsupported: 'Your browser does not support read aloud.',
    ttsNotSupported: 'Your browser does not support read aloud.',
    ttsStartFailed: 'Could not start reading aloud: {reason}',
    colors: {
      yellow: 'Yellow',
      green: 'Green',
      blue: 'Blue',
      pink: 'Pink',
      orange: 'Orange',
    },
    highlightIn: 'Highlight in {color}',
    summarizeSelection: 'Summarize selection with AI',
    explainSelection: 'Explain selection with AI',
    translateSelection: 'Translate selection',
    bookmarkSelection: 'Bookmark position',
    defineWord: 'Define word',
    addNote: 'Add note',
    selection: {
      highlight: 'Highlight',
      summarize: 'Summarize',
      explain: 'Explain',
      translate: 'Translate',
      bookmark: 'Bookmark',
      define: 'Define',
    },
    annotationAdded: 'Highlight added',
    annotationRemoved: 'Annotation removed',
    editAnnotation: 'Edit annotation',
    note: 'Note',
    notePlaceholder: 'Write a note…',
    noteEdit: 'Edit',
    notePreview: 'Preview',
    noteEmpty: 'Nothing to preview yet.',
    color: 'Color',
    bookmarkAdded: 'Bookmark added',
    bookmarkRemoved: 'Bookmark removed',
    bookmarkLabel: 'Bookmark',
    bookmarkNavigateHint: 'Navigate to a page to bookmark it.',
    exportJson: 'Export JSON',
    exportMarkdown: 'Export MD',
    exportJsonDone: 'Annotations exported (JSON)',
    exportMarkdownDone: 'Annotations exported (Markdown)',
    importJson: 'Import JSON',
    importDone: '{added} annotations imported',
    importWithSkipped: '{added} imported, {skipped} already existed',
    importFailed: 'Import failed: {reason}',
    bookmarkFailed: 'Could not bookmark: {reason}',
    backToLibrary: 'Back to library',
    regenerateError: 'Error: {reason}',
  },
  ai: {
    requiresAuth: 'AI requires signing in',
    requiresAuthHint: 'Sign in with your account to configure and use AI features.',
    signIn: 'Sign in',
    summarizing: 'Generating…',
    summarizingWait: 'Waiting for model response…',
    summarizeChapter: 'Summarize chapter',
    summarizeBook: 'Summarize book',
    summaryDone: 'Summary generated',
    summaryChapterDone: 'Chapter summary generated',
    summaryBookDone: 'Book summary generated',
    explainDone: 'Explanation generated',
    summaryFailed: 'Could not generate summary: {reason}',
    summaryHighlightsDone: 'Summary of your annotations generated',
    explainFailed: 'Could not generate explanation: {reason}',
    summaryEmpty: 'No text in this chapter to summarize.',
    summaryBookEmpty: 'Not enough text to summarize the book.',
    summaryRegenerated: 'Summary regenerated',
    summaryCopied: 'Summary copied to clipboard',
    copyFailed: 'Could not copy.',
    error: {
      invalidKey: 'The API key is not valid. Check it in Settings → AI.',
      missingKey: 'No API key configured. Add one in Settings → AI.',
      quota: 'Your account ran out of credits or hit the rate limit. Check your plan with the provider.',
      modelNotFound: 'The configured model is unavailable. Change it in Settings → AI.',
      network: 'Could not reach the AI provider. Check your connection.',
    },
    chatTitle: 'Chat about the book',
    chatContextHint: 'Answers based on the current chapter',
    chatEmpty: 'Ask a question about what you are reading.\nAnswers are based on the current chapter.',
    chatPlaceholder: 'Type a question…',
    chatSend: 'Send',
    chatNoChapter: 'No chapter text available to ground the answer.',
    chatFailed: 'Could not answer: {reason}',
    summaryPanelEmpty: 'No summaries yet.\nSelect text or use the buttons above.',
    translating: 'Translating…',
    translationDone: 'Translation generated',
    translationFailed: 'Could not translate: {reason}',
    translationCopied: 'Translation copied',
    translationPanelEmpty: 'No translations yet.\nSelect text and press "Translate".',
    generatingCancelled: 'Generation cancelled.',
    dictionary: {
      title: 'Definition',
      searching: 'Searching…',
      consulting: 'Consulting dictionary…',
      notFound: '"{word}" was not found in the dictionary.',
      noResults: 'No results for "{word}".',
    },
    settings: {
      mode: 'Connection mode',
      direct: 'Direct',
      directDesc: 'Your API key is stored only in this browser.',
      proxy: 'Proxy',
      proxyDesc: 'The key lives on a server (more secure).',
      proxyEndpoint: 'Proxy endpoint',
      proxyPlaceholder: 'https://your-worker.workers.dev',
      proxyToken: 'Proxy token',
      proxyTokenPlaceholder: 'Must match the Worker APP_TOKEN',
      activeProvider: 'Active provider',
      tts: 'Neural voice (audiobook)',
      ttsHint: 'Who synthesizes your books. ElevenLabs uses its own key and works with any active provider.',
      elevenLabsKey: 'ElevenLabs API key',
      elevenLabsKeyHint: 'Sent straight from this browser: Proxy mode only routes OpenAI.',
      generation: 'Generation',
      temperature: 'Temperature (creativity)',
      temperatureHint: 'Lower = more faithful to text; higher = more creative.',
      summaryLanguage: 'Summary language',
      syncedToAccount: 'Synced with your account',
      localOnly: 'This device only',
      syncError: 'Sync error — check Diagnostics',
    },
    usage: {
      title: 'AI usage',
      today: 'Today',
      month: 'This month',
      tokens: 'tokens',
      empty: "You haven't used any AI features yet. Consumed tokens will appear here.",
      localHint: 'Offline mode: showing only recent local activity (not synced).',
      refreshing: 'Refresh',
    },
  },
  sync: {
    enabled: 'Synchronization',
    enable: 'Enable sync',
    supabaseUrl: 'Supabase URL',
    supabaseKey: 'Anon key',
    connected: 'Real-time synced',
    connecting: 'Connecting…',
    saving: 'Saving to cloud…',
    savingLabel: 'Saving',
    syncLabel: 'Sync',
    offlineBanner: 'Offline — changes are saved locally and will sync when back online.',
    configRequired: 'Supabase configuration is missing (define it in .env.local).',
    envMissing: 'Supabase is not configured. Set VITE_SUPABASE_URL and VITE_SUPABASE_PUBLISHABLE_KEY in the project .env.local file and restart the dev server.',
    sessionActive: 'Signed in',
    sessionOk: 'Connection OK — session active.',
    sessionOkNoSession: 'Connection OK. Sign in to sync.',
    connectionFailed: 'Connection failed: {reason}',
    notSignedIn: 'You are not signed in.',
    signInOrUp: 'Sign in / Sign up',
    projectUrl: 'Project URL',
    urlPlaceholder: 'https://xxxx.supabase.co',
    anonKey: 'Anon key',
    anonKeyHint: 'Find it in Supabase → Settings → API. It is public (not a secret).',
    testing: 'Testing…',
    testConnection: 'Test connection',
    syncDescription: 'When sync is enabled, your annotations, summaries, translations and progress merge automatically across devices (CRDT). EPUB files are uploaded on demand.',
    autoUploadOnImport: 'Automatically upload to the cloud on import',
    autoUploadOnImportHint: 'Each EPUB you import will be uploaded to the cloud in the background (if signed in).',
    configured: 'Credentials configured (via environment)',
  },
  auth: {
    signIn: 'Sign in',
    signUp: 'Sign up',
    signOut: 'Sign out',
    email: 'Email',
    password: 'Password',
    sessionStarted: 'Session started',
    accountCreated: 'Account created',
    profile: 'Profile',
    editProfile: 'Edit profile',
    profileSaved: 'Profile saved.',
    avatar: 'Avatar',
    avatarUpdated: 'Avatar updated.',
    displayName: 'Public name',
    displayNamePlaceholder: 'Your name (visible in feed and shared books)',
    bio: 'Bio',
    bioPlaceholder: 'Tell other readers about yourself…',
    noBio: 'No bio.',
    makePublic: 'Public profile (visible to other readers)',
    publicProfile: 'Public profile',
    inviteCode: 'Invite code',
    inviteCodePlaceholder: 'EPUB-XXXXXX-XXXXXX',
    inviteCodeInvalid: 'Invalid, expired or already used code.',
    inviteCodeValid: 'Valid code.',
    inviteCodeRequired: 'You need a valid invite code to sign up.',
    confirmEmail: 'Check your email to confirm your account.',
    sessionClosed: 'Session closed.',
    modeLogin: 'login',
    modeSignup: 'signup',
    haveAccount: 'Already have an account? Sign in',
    noAccount: "Don't have an account? Sign up",
    sessionActive: 'Signed in',
    goToLibrary: 'Go to library',
    createTitle: 'Create account',
    signinSubtitle: 'Sync your library, annotations and summaries across devices.',
    emailPlaceholder: "you{'@'}email.com",
    passwordPlaceholder: '••••••••',
    processing: 'Processing…',
    signInShort: 'Sign in',
    signUpShort: 'Sign up',
    noAccountShort: 'No account?',
    haveAccountShort: 'Already have an account?',
    signUpLink: 'Sign up',
    signInLink: 'Sign in',
    continueWithoutSync: 'Continue without sync',
    memberSince: 'Member since {date}',
    syncActive: 'Sync active',
    syncInactive: 'Not synced',
    syncStatusHint: 'Your books, annotations and shelves are saved to the cloud.',
    syncOffHint: 'Your data lives only on this device. Enable sync in Settings to back it up.',
    goToSyncSettings: 'Sync settings',
    forgotPassword: 'Forgot your password?',
    resetPasswordTitle: 'Reset password',
    resetPasswordHint: "We'll email you instructions to reset it.",
    resetPasswordSent: 'Check your inbox: we sent instructions to reset your password.',
    resetPasswordCancel: 'Back',
    sendResetLink: 'Send link',
    aiLockedTitle: 'AI config locked',
    aiLockedHint: 'Enter your password to sync your AI settings across devices.',
    unlock: 'Unlock',
    unlocking: 'Unlocking…',
    unlocked: 'AI settings unlocked and synced.',
    confirmPassword: 'Confirm password',
    confirmPasswordPlaceholder: '••••••••',
    passwordMismatch: 'Passwords do not match.',
    showPassword: 'Show password',
    hidePassword: 'Hide password',
    passwordStrengthWeak: 'weak',
    passwordStrengthFair: 'fair',
    passwordStrengthStrong: 'strong',
    emailInvalid: 'Invalid email.',
    whatSyncGives: 'What you get by syncing',
    syncBenefitLibrary: 'Your library on all your devices',
    syncBenefitAnnotations: 'Annotations and summaries always available',
    syncBenefitShelves: 'Shelves and review cards synced',
    syncBenefitBackup: 'Automatic cloud backup',
  },
  stats: {
    title: 'Statistics',
    wrappedTitle: 'Your year {year}',
    wrappedHours: 'Reading hours',
    wrappedDays: 'Days read',
    wrappedStreak: 'Longest streak',
    wrappedBooksRead: 'Books read',
    wrappedBooksFinished: 'Books finished',
    wrappedHighlights: 'Annotations',
    wrappedTopBook: 'Most read book',
    wrappedColors: 'Annotations by color',
    totalTime: 'Total time',
    currentStreak: 'Current streak',
    streakDays: 'days',
    reading: 'Reading',
    finished: 'Finished',
    last14Days: 'Last 14 days',
    mostRead: 'Most read',
    unknown: 'Unknown',
    empty: 'No data yet. Open a book and start reading to see your stats.',
    dailyGoal: 'Daily goal',
    goalTarget: 'Target',
    goalMinutes: 'min',
    goalMet: 'Goal achieved! 🎉',
    goalRemaining: '{minutes} min to go.',
    goalSetHint: 'Set a goal to motivate yourself.',
    today: 'today',
  },
  settings: {
    title: 'Settings',
    appearance: 'Appearance',
    theme: 'Theme',
    themeDark: 'Dark',
    themeLight: 'Light',
    themeSepia: 'Sepia',
    highlightColors: 'Highlight colors',
    appMode: 'App mode',
    appModeHint: 'Interface appearance. Independent of the reader theme.',
    modeLight: 'Light',
    modeDark: 'Dark',
    modeSystem: 'System',
    language: 'Language',
    typography: 'Typography',
    fontFamily: 'Font',
    fontSize: 'Size',
    lineHeight: 'Line height',
    margin: 'Margin',
    letterSpacing: 'Letter spacing',
    wordSpacing: 'Word spacing',
    paragraphSpacing: 'Paragraph spacing',
    accessibility: 'Accessibility',
    dyslexicFont: 'OpenDyslexic font',
    bionicReading: 'Bionic reading',
    bionicWarning: 'Bionic reading may shift existing annotations in that section.',
    ttsHighlight: 'Highlight while reading aloud',
    keepScreenAwake: 'Keep screen awake while reading',
    keepScreenAwakeHint: 'Prevents the screen saver from activating while you read. Uses more battery.',
    readingGoals: 'Reading goals',
    dailyGoal: 'Daily goal (min)',
    sync: 'Sync',
    ai: 'Artificial intelligence',
    about: 'About',
    diagnostics: 'Diagnostics',
    backup: 'Backup',
    backupHint: 'Export your full library (books, annotations, progress) to a .epubu file. It does not include your API keys or credentials.',
    backupExport: 'Export library',
    backupImport: 'Import library',
    backupExportDone: 'Library exported.',
    backupExportFailed: 'Could not export: {reason}',
    backupImportDone: 'Imported {books} book(s) and {annotations} annotation(s). {skipped} duplicate(s) skipped.',
    backupImportFailed: 'Could not import: {reason}',
    version: 'Version',
  },
  pwa: {
    updateAvailable: 'A new version is available.',
    reload: 'Reload',
    offlineReady: 'Ready to use offline.',
  },
  errors: {
    generic: 'Something went wrong.',
    network: 'Network error.',
    notFound: 'Not found.',
    invalid: 'Invalid.',
    quota: 'Out of storage space. Remove old books.',
    bookNotFound: 'Book not found.',
    openBookFailed: 'Could not open the book: {reason}',
    searchFailed: 'Search failed: {reason}',
    settingsCorrupt: 'Corrupt settings; using defaults.',
  },
  notif: {
    title: 'Notifications',
    empty: 'You have no notifications.',
    markAllRead: 'Mark all as read',
    generic: 'You have a new notification.',
    shareInvited: '{sharer} shared a book with you.',
    memberJoined: '{name} joined a shared book.',
    highlightCommented: '{author} commented on one of your highlights.',
    newFollower: '{name} follows you.',
  },
  profile: {
    anonymous: 'Anonymous',
    notFound: 'Profile not found or private.',
    follow: 'Follow',
    unfollow: 'Unfollow',
    followingToast: 'You are now following this user.',
    unfollowed: 'You unfollowed this user.',
    followers: 'followers',
    following: 'following',
    editOwn: 'Edit',
    placeholder: 'Coming soon: public highlights and books from this reader.',
  },
  clubs: {
    title: 'Reading clubs',
    subtitle: 'Read and discuss in a group.',
    new: 'New club',
    create: 'Create club',
    created: 'Club created.',
    createFailed: 'Could not create the club.',
    name: 'Name',
    description: 'Description',
    empty: 'No clubs yet. Create the first one.',
    join: 'Join',
    leave: 'Leave',
    joined: 'You joined the club.',
    left: 'You left the club.',
    members: 'Members',
    membersCount: 'members',
    books: 'Club books',
    noBooks: 'No books in this club yet.',
    notFound: 'Club not found.',
  },
  moderation: {
    title: 'Moderation',
    subtitle: 'Review reports and hide inappropriate highlights.',
    tabReports: 'Reports',
    tabHidden: 'Hidden',
    noReports: 'No open reports.',
    noHidden: 'No hidden highlights.',
    resolved: 'Report resolved.',
    dismissed: 'Report dismissed.',
    hidden: 'Highlight hidden.',
    unhidden: 'Highlight visible again.',
    unhide: 'Show',
  },
  invitations: {
    title: 'Invitations',
    subtitle: 'Generate one-time codes to invite new users.',
    generate: 'Generate code',
    created: 'Code generated.',
    createFailed: 'Could not generate the code.',
    code: 'Code',
    status: 'Status',
    reservedFor: 'Reserved for',
    usedBy: 'Used by',
    expires: 'Expires',
    note: 'Note',
    notePlaceholder: 'Who is this code for (optional)',
    revoke: 'Revoke',
    revokeConfirm: 'Revoke this code? It will no longer be usable.',
    revoked: 'Code revoked.',
    copyLink: 'Copy link',
    copyCode: 'Copy code',
    linkCopied: 'Link copied to clipboard.',
    codeCopied: 'Code copied.',
    empty: 'No codes yet. Generate the first one above.',
  },
  admin: {
    title: 'Administration',
    backToApp: 'Back to app',
    nav: {
      overview: 'Overview',
      users: 'Users',
      events: 'Events',
      email: 'Email',
      audit: 'Audit',
      moderation: 'Moderation',
      invitations: 'Invitations',
      system: 'System',
    },
    overview: {
      title: 'Overview',
      subtitle: 'Aggregated usage metrics for the whole app.',
      totalUsers: 'Total users',
      activeToday: 'Active today',
      active7d: 'Active 7d',
      active30d: 'Active 30d',
      newUsers30d: 'New (30d)',
      cloudBooks: 'Cloud books',
      readingTime: 'Reading time',
      aiTokens: 'AI tokens',
      last90d: 'last 90 days',
      activityTitle: 'Activity (last 30 days)',
      providerUsage: 'AI provider usage',
      requests: 'reqs',
      tokens: 'tokens',
    },
    users: {
      title: 'Users',
      subtitle: '{n} registered user(s) | {n} registered user | {n} registered users',
      searchPlaceholder: 'Search by email…',
      colEmail: 'Email',
      colRole: 'Role',
      colCreated: 'Joined',
      colLastSeen: 'Last seen',
      colActions: 'Actions',
      you: 'you',
      bannedBadge: 'banned',
      empty: 'No results.',
      justNow: 'just now',
      minAgo: '{n}m ago',
      hourAgo: '{n}h ago',
      dayAgo: '{n}d ago',
      actions: {
        promote: 'Promote to admin',
        demote: 'Remove admin',
        ban: 'Ban',
        unban: 'Unban',
        'promote.done': 'User promoted to admin.',
        'demote.done': 'Admin rights removed.',
        'ban.done': 'User banned.',
        'unban.done': 'User unbanned.',
      },
      confirm: {
        promote: { title: 'Promote to admin', body: 'This user will be able to see all data and manage the app. Confirm?' },
        demote: { title: 'Remove admin rights', body: 'The user will lose access to the admin panel.' },
        ban: { title: 'Ban user', body: 'The user will not be able to sign in until reactivated.' },
        unban: { title: 'Unban user', body: 'The user will be able to sign in again.' },
      },
    },
    events: {
      title: 'Events',
      subtitle: 'Event feed for debugging and metrics.',
      filterType: 'Type',
      filterUser: 'User (UUID)',
      allTypes: 'All types',
      userUuidPlaceholder: 'Full UUID',
      colTime: 'Date',
      colType: 'Type',
      colUser: 'User',
      colProps: 'Data',
      empty: 'No events for these filters.',
      showing: 'Showing {n} event(s).',
    },
    email: {
      title: 'Transactional email',
      subtitle: 'Resend integration for Auth and notifications.',
      statusTitle: 'Integration status',
      smtpTransport: 'Auth SMTP (Supabase)',
      smtpHint: 'Configure in Supabase dashboard → Auth → SMTP',
      edgeFunction: 'Edge Function (Resend API)',
      noSupabase: 'Supabase not configured in Settings',
      setupHint: 'See the setup guide at',
      testTitle: 'Send a test',
      recipient: 'Recipient',
      sendTest: 'Send test email',
      testSent: 'Email sent (check the inbox and the log).',
      enterRecipient: 'Provide a destination email.',
      configSyncFirst: 'Configure Supabase in Settings → Sync to enable sending.',
      broadcastTitle: 'Broadcast to users',
      broadcastHint: 'Send a template to all active users. Admins only.',
      broadcastTemplate: 'Template',
      broadcastVars: 'Variables (JSON)',
      broadcastActiveDays: 'Only active in the last',
      broadcastDays: 'days (0 = all)',
      sendBroadcast: 'Send broadcast',
      broadcastOk: 'Broadcast sent to {n} recipient(s).',
      broadcastPartial: 'Sent: {ok}. Failed: {fail}. Check the log.',
      broadcastResult: '✓ {sent} sent · {failed} failed',
      invalidVars: 'Invalid JSON variables.',
      history: 'Send history',
      colWhen: 'Date',
      colTo: 'To',
      colTemplate: 'Template',
      colStatus: 'Status',
      noLogs: 'No emails sent yet.',
    },
    audit: {
      title: 'Audit log',
      subtitle: 'Record of administrative actions.',
      colWhen: 'Date',
      colActor: 'Actor',
      colAction: 'Action',
      colTarget: 'Target',
      colMeta: 'Detail',
      empty: 'No actions recorded.',
    },
    system: {
      title: 'System',
      subtitle: 'Database (Supabase) connection status. Read-only.',
      host: 'Project host',
      credentialsSource: 'Credentials',
      viaEnv: 'Injected at build time (environment variables)',
      note: 'Credentials are set at deployment and are neither shown nor edited here. This view only reports connection status.',
    },
  },
}
